// import { defineCancelApiObject } from './configs/axiosUtils';
import { callApi } from '../../apiCaller';
import { toastError } from '../../utils';

const COUPON_ENDPOINT = 'coupon';

export const CouponAPI = {
     get: async (id, cancel = false) => {
          const endpoint = `${COUPON_ENDPOINT}/:id`.replace(':id', id);

          // // Retrieving the signal value by using the property name
          // signal: cancel ? cancelApiObject[this.get.name].handleRequestCancellation().signal : undefined,
          return await callApi(endpoint, 'GET').then((response) => {
               if (response.status !== 200) {
                    toastError(response);
                    return;
               }

               return response.data;
          });
     },
     getAll: async (cancel = false) => {
          const endpoint = COUPON_ENDPOINT;

          return await callApi(endpoint, 'GET').then((response) => {
               if (response.status !== 200) {
                    toastError(response);
                    return;
               }

               return response.data;
          });
     },
     create: async (payload, cancel = false) => {
          const endpoint = COUPON_ENDPOINT;

          return await callApi(endpoint, 'POST', payload).then((response) => {
               if (response.status !== 200) {
                    toastError(response);
                    return;
               }

               return response.data;
          });
     },
     verify: async (payload, cancel = false) => {
          const { code, ...restPayload } = payload;
          const endpoint = `${COUPON_ENDPOINT}/verify?code=:code`.replace(':code', code);

          return await callApi(endpoint, 'POST', restPayload).then((response) => {
               if (response.status !== 200) {
                    toastError(response);
                    return;
               }

               return response.data;
          });
     },
};

// // Defining the cancel API object for CouponAPI
// const cancelApiObject = defineCancelApiObject(CouponAPI);
